module.exports = __webpack_public_path__ + "app-static/img/p_05.e2bf01ae.jpg";